import { FCC } from '@dynamika-shared/types/general';
import { LayoutView } from './Layout.view';
import { NavigationBlockerProvider } from '@hooks/useNavigationBlocker';
import React from 'react';
import { useSettingsSlice } from '@restore/settings/settings.slice';

type LayoutProps = {
  className?: string;
  menuComponent?: React.ComponentType<{
    sidebarCollapsed: boolean | undefined;
  }>;
};

export const Layout: FCC<LayoutProps> = ({
  children,
  className,
  menuComponent: MenuComponent,
}) => {
  const sidebarCollapsed = useSettingsSlice(state => state.sidebarCollapsed);
  return (
    <NavigationBlockerProvider>
      <LayoutView
        className={className}
        MenuComponent={
          MenuComponent as React.FunctionComponent<{
            sidebarCollapsed: boolean | undefined;
          }>
        }
        sidebarCollapsed={sidebarCollapsed}
      >
        {children}
      </LayoutView>
    </NavigationBlockerProvider>
  );
};
